export const PUBLIC_MISSING_REASON_LABELS = {
  not_verified_live: "Not verified live",
  not_published: "Not published",
  status_not_open: "Sold out/closed/expired",
  missing_title: "Missing title",
  missing_ticket_price: "Missing ticket price",
  missing_max_tickets: "Missing max tickets",
  missing_date: "Missing draw/closing date",
  missing_source_image: "Missing source image",
  invalid_llf_detail_url: "Invalid source URL",
  closed_or_sold_out: "Sold out/closed/expired",
  expired_or_past_date: "Expired/closed",
  not_dcg_v2: "Not DCG V2",
  status_not_public: "Status is not public",
  unsupported_public_operator: "Unsupported public operator",
  public_readiness_unknown: "Public readiness unknown",
  ticket_cap_missing: "Missing ticket cap",
  odds_unavailable: "Odds unavailable",
  operator_ticket_cap_unclear: "Operator ticket cap unclear",
  missing_prize_value: "Missing prize value",
  free_entry_unclear: "Free entry unclear",
  extension_policy_unclear: "Extension policy unclear",
};

export function publicMissingReasonLabel(reason) {
  return PUBLIC_MISSING_REASON_LABELS[reason] || String(reason || "Blocked");
}

export function publishStatusForCompetition(comp = {}) {
  const hasReport = !!comp.public_visibility;
  const report = comp.public_visibility || {};
  const missingReasons = Array.isArray(report.missing_reasons)
    ? report.missing_reasons
    : [];
  const warningReasons = Array.isArray(report.warning_reasons)
    ? report.warning_reasons
    : [];
  const blockers = missingReasons.filter((reason) => reason !== "not_published");
  const dataStatus = comp.competition_data_status || "source_unverified";
  const publishStatus = comp.publish_status || "draft";
  const published = publishStatus === "published" && report.publicly_visible === true;
  const verified = dataStatus === "verified_live";

  if (!hasReport) {
    return {
      label: "Readiness unknown",
      tone: "bg-slate-500/20 text-slate-200 border-slate-500/30",
      verificationLabel: dataStatus.replace(/_/g, " "),
      publishLabel: publishStatus,
      missingReasons: ["public_readiness_unknown"],
      warningReasons: [],
      blockers: ["public_readiness_unknown"],
      canPublish: false,
      canVerify: false,
      primaryActionLabel: "Refresh readiness",
      publishTitle: "Refresh the admin list to check public readiness",
    };
  }

  if (published) {
    return {
      label: "Published",
      tone: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30",
      verificationLabel: "Verified live",
      publishLabel: "Published",
      missingReasons,
      warningReasons,
      blockers,
      canPublish: false,
      canVerify: false,
      primaryActionLabel: "Published",
      publishTitle: "Already published",
    };
  }

  if (!verified) {
    return {
      label: "Review needed",
      tone: "bg-amber-500/15 text-amber-200 border-amber-500/30",
      verificationLabel: dataStatus.replace(/_/g, " "),
      publishLabel: publishStatus,
      missingReasons,
      warningReasons,
      blockers,
      canPublish: false,
      canVerify: true,
      primaryActionLabel: "Review / Verify",
      publishTitle: "Verify this record before publishing",
    };
  }

  if (blockers.length === 0) {
    const hasWarnings = warningReasons.length > 0;
    return {
      label: hasWarnings
        ? `Ready with warnings: ${warningReasons.slice(0, 2).map(publicMissingReasonLabel).join(" / ")}`
        : "Ready to publish",
      tone: hasWarnings
        ? "bg-amber-500/15 text-amber-200 border-amber-500/30"
        : "bg-sky-500/20 text-sky-200 border-sky-500/30",
      verificationLabel: "Verified live",
      publishLabel: publishStatus === "published" ? "Published" : "Draft",
      missingReasons,
      warningReasons,
      blockers,
      canPublish: publishStatus !== "published",
      canVerify: false,
      primaryActionLabel: publishStatus === "published" ? "Published" : "Publish",
      publishTitle: hasWarnings
        ? `Can publish with warnings: ${warningReasons.map(publicMissingReasonLabel).join(", ")}`
        : "Publish to public competitions",
    };
  }

  const firstBlocker = publicMissingReasonLabel(blockers[0]);
  return {
    label: `Blocked: ${firstBlocker.replace(/^Missing /, "missing ")}`,
    tone: "bg-red-500/15 text-red-200 border-red-500/30",
    verificationLabel: "Verified only",
    publishLabel: publishStatus === "published" ? "Published" : "Draft",
    missingReasons,
    warningReasons,
    blockers,
    canPublish: false,
    canVerify: false,
    primaryActionLabel: "Fix blockers",
    publishTitle: `Blocked: ${blockers.map(publicMissingReasonLabel).join(", ")}`,
  };
}
